import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  Squares2X2Icon,
  PlusIcon,
  PlayIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  Squares2X2Icon as Squares2X2IconSolid,
  PlayIcon as PlayIconSolid,
  UserCircleIcon as UserCircleIconSolid,
} from '@heroicons/react/24/solid';

interface NavItem {
  id: string;
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
  label: string;
  path: string;
  isCenter?: boolean;
}

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems: NavItem[] = [
    {
      id: 'home',
      icon: <HomeIcon style={{ width: 24, height: 24 }} />,
      activeIcon: <HomeIconSolid style={{ width: 24, height: 24 }} />,
      label: 'Home',
      path: '/',
    },
    {
      id: 'categories',
      icon: <Squares2X2Icon style={{ width: 24, height: 24 }} />,
      activeIcon: <Squares2X2IconSolid style={{ width: 24, height: 24 }} />,
      label: 'Categories',
      path: '/categories',
    },
    {
      id: 'post',
      icon: <PlusIcon style={{ width: 28, height: 28 }} />,
      activeIcon: <PlusIcon style={{ width: 28, height: 28 }} />,
      label: 'Post',
      path: '/post-ad',
      isCenter: true,
    },
    {
      id: 'stories',
      icon: <PlayIcon style={{ width: 24, height: 24 }} />,
      activeIcon: <PlayIconSolid style={{ width: 24, height: 24 }} />,
      label: 'Stories',
      path: '/stories',
    },
    {
      id: 'menu',
      icon: <UserCircleIcon style={{ width: 24, height: 24 }} />,
      activeIcon: <UserCircleIconSolid style={{ width: 24, height: 24 }} />,
      label: 'Menu',
      path: '/menu',
    },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 d-md-none"
      style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px) saturate(180%)',
        borderTop: '1px solid rgba(244, 223, 204, 0.7)',
        boxShadow: '0 -4px 24px rgba(116, 67, 35, 0.08)',
        zIndex: 1050,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="d-flex align-items-center justify-content-around py-2">
        {navItems.map((item) => {
          const active = isActive(item.path);
          const icon = active ? item.activeIcon : item.icon;

          if (item.isCenter) {
            return (
              <button
                key={item.id}
                onClick={() => navigate(item.path)}
                className="d-flex flex-column align-items-center border-0 bg-transparent position-relative"
                style={{ marginTop: -22 }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, var(--pw-accent) 0%, #f5a623 100%)',
                    color: '#5c3d0d',
                    boxShadow: '0 6px 20px rgba(255, 191, 77, 0.4)',
                    transition: 'transform 0.2s ease',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                  {icon}
                </div>
              </button>
            );
          }

          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className="d-flex flex-column align-items-center justify-content-center border-0 bg-transparent"
              style={{
                padding: '8px 12px',
                borderRadius: 14,
                minWidth: 60,
                color: active ? 'var(--pw-primary)' : 'var(--pw-text-muted)',
                background: active ? 'rgba(232, 93, 76, 0.08)' : 'transparent',
                transition: 'all 0.15s ease',
              }}
            >
              {icon}
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  marginTop: 4,
                  color: active ? 'var(--pw-primary)' : 'var(--pw-text-muted)',
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
